import React, { useState, useEffect } from 'react'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import './terms.scss'
import Footer from '../../components/Footer/Footer'

const Terms = () => {

    useEffect(() => {
        document.title = 'FlashRoom Terms'
    }, [])

    const [nav, openNav] = useState(false);


    useEffect(() => {
        if (!nav) {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        const scrollY = window.scrollY;

        document.documentElement.classList.add("nav-blur");

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);


    return (
        <div id='terms-page'>

            <div className='nav-wrapper'>
                <div className='nav-2'>

                    <div className='nav-logo-container'>
                        <img src='images/flashroom-logo-light.png' height="44px" />
                        <h1>Flash<span>Room</span></h1>
                    </div>

                    <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                        <div />
                        <div />
                        <div />
                    </div>

                </div>
            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>

            <div className="terms-content">
                <div className="terms-card">
                    <h1>Terms & Conditions</h1>

                    <p className="effective-date">
                        <strong>Effective Date:</strong> February 3, 2026
                    </p>

                    <p>
                        Welcome to FlashRoom. By accessing or using FlashRoom,
                        you agree to these Terms & Conditions. If you do not agree, please do not use the Service.
                    </p>

                    <div className="callout">
                        <h3>Beta Service</h3>
                        <p>
                            FlashRoom is currently in beta. Features may change, break, or be removed as we continue
                            development. Use the Service at your own discretion.
                        </p>
                    </div>

                    <h2>1. Acceptable Use</h2>
                    <p>
                        FlashRoom is intended for collaboration, learning, and sharing files or code in a respectful
                        and lawful way. You agree not to use the Service to upload, share, or distribute:
                    </p>

                    <ul>
                        <li>Illegal content or content that promotes illegal activity</li>
                        <li>Explicit content</li>
                        <li>Hate speech, harassment, threats, or abusive behavior</li>
                        <li>Content that exploits or harms minors</li>
                        <li>Malware, viruses, or attempts to exploit systems or users</li>
                        <li>Content that infringes intellectual property or privacy rights</li>
                        <li>Personally sensitive information you do not have the right to share</li>
                    </ul>

                    <h2>2. Misuse of the Service</h2>
                    <p>You agree not to:</p>
                    <ul>
                        <li>Attempt to bypass authentication, room permissions, or access controls</li>
                        <li>Disrupt, overload, or abuse the Service or infrastructure</li>
                        <li>Use FlashRoom for spam, scams, or deceptive behavior</li>
                        <li>Automate usage in a way that negatively impacts performance</li>
                        <li>Use the Service in a way that interferes with other users</li>
                    </ul>

                    <h2>3. User Content</h2>
                    <p>
                        You are responsible for all content you upload or create within FlashRoom (“User Content”).
                        You retain ownership of your content, but you grant FlashRoom permission to host, store,
                        and display it solely to operate the Service.
                    </p>

                    <p>
                        We do not actively monitor all content, but we reserve the right to remove content or restrict
                        access if we believe it violates these Terms or poses a risk to users or the Service.
                    </p>

                    <h2>4. Storage & Availability</h2>
                    <p>
                        FlashRoom does not guarantee permanent storage. During beta, rooms or files may be removed due
                        to inactivity, storage limits, maintenance, or product changes.
                    </p>

                    <h2>5. Suspension & Termination</h2>
                    <p>
                        We may suspend or terminate access to FlashRoom, remove content, or restrict functionality
                        at our discretion if these Terms are violated or if necessary to protect the Service or users.
                    </p>

                    <h2>6. Disclaimer</h2>
                    <p>
                        FlashRoom is provided “as is” and “as available” without warranties of any kind. We do not
                        guarantee uninterrupted service, error-free operation, or data retention.
                    </p>

                    <h2>7. Limitation of Liability</h2>
                    <p>
                        To the fullest extent permitted by law, FlashRoom will not be liable for any indirect,
                        incidental, or consequential damages, including loss of data or content.
                    </p>

                    <h2>8. Changes to These Terms</h2>
                    <p>
                        We may update these Terms from time to time. Continued use of the Service after changes
                        means you accept the updated Terms.
                    </p>

                    <h2>9. Contact</h2>
                    <p>
                        Questions about these Terms? Email us at{" "}
                        <a href="mailto:flashroomshare@gmail.com">flashroomshare@gmail.com</a>.
                    </p>

                    <div className="divider" />

                    <p className="fineprint">
                        These Terms are provided for general informational purposes and do not constitute legal advice.
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Terms
